window.__shouldiOSFix = undefined;

function iosOnFocus() {
	if (window.__shouldiOSFix === undefined) {
		if (window.navigator.userAgent.indexOf("FagligeDageiOS") !== -1) {
			window.__shouldiOSFix = true;
		} else {
			window.__shouldiOSFix = false;
		}
	}

	if (window.__shouldiOSFix) {
		//window.scrollTo(0, 0);
		//document.body.scrollTop = 0;
	}
}
